// extracted by mini-css-extract-plugin
export var button = "styles-module--button--03f72";
export var buttonContainer = "styles-module--buttonContainer--f363d";
export var container = "styles-module--container--cfb96";
export var icon = "styles-module--icon--7f1e3";
export var text = "styles-module--text--9e46f";